import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100vw;
  height: 100%;
  background-image: linear-gradient(
    to top right,
    ${({ theme }) => theme.borderWordle}
  );
  padding: 0.3rem;
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;
